import { render } from "./Sandbox.vue?vue&type=template&id=397d1803"
import script from "./Sandbox.vue?vue&type=script&lang=js"
export * from "./Sandbox.vue?vue&type=script&lang=js"

import "./Sandbox.vue?vue&type=style&index=0&id=397d1803&lang=css"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__